import React from 'react';
import { Activity, Database, GitMerge, ShieldAlert, Target, PieChart, BellRing, Landmark, Calculator, Menu, X, Plug, Smartphone } from 'lucide-react';
interface SidebarProps {
  activeSection: string;
  setActiveSection: (section: string) => void;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}
export function Sidebar({
  activeSection,
  setActiveSection,
  isOpen,
  setIsOpen
}: SidebarProps) {
  const navSections = [{
    title: 'Overview',
    items: [{
      id: 'exec-summary',
      label: 'Executive Summary',
      icon: Activity
    }]
  }, {
    title: 'Decisioning Engine',
    items: [{
      id: 'layer-1',
      label: 'Layer 1: Data Ingestion',
      icon: Database
    }, {
      id: 'layer-2',
      label: 'Layer 2: Feature Engineering',
      icon: GitMerge
    }, {
      id: 'layer-3',
      label: 'Layer 3: Eligibility Gates',
      icon: ShieldAlert
    }, {
      id: 'layer-4',
      label: 'Layer 4: Predictive Scorecard',
      icon: Target
    }, {
      id: 'layer-5',
      label: 'Layer 5: Loan Sizing',
      icon: PieChart
    }, {
      id: 'layer-6',
      label: 'Layer 6: Live Monitoring',
      icon: BellRing
    }]
  }, {
    title: 'Integrations & Experience',
    items: [{
      id: 'integrations',
      label: 'Third-Party Data',
      icon: Plug
    }, {
      id: 'merchant',
      label: 'Merchant Interface',
      icon: Smartphone
    }, {
      id: 'bank-interface',
      label: 'Bank Interface',
      icon: Landmark
    }]
  }, {
    title: 'Tools',
    items: [{
      id: 'calculator',
      label: 'Interactive Calculator',
      icon: Calculator
    }]
  }];
  return <>
      {/* Mobile overlay */}
      {isOpen && <div className="fixed inset-0 bg-slate-900/50 z-40 lg:hidden" onClick={() => setIsOpen(false)} data-id="element-567" />}

      {/* Sidebar */}
      <div className={`
        fixed top-0 left-0 h-full bg-navy-900 text-slate-300 w-72 z-50 flex flex-col
        transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `} data-id="element-568">
        <div className="p-6 flex items-center justify-between border-b border-slate-800/60" data-id="element-569">
          <div className="flex items-center gap-3 text-white" data-id="element-570">
            <img src="https://cdn.magicpatterns.com/uploads/jwMNkiJLrVq1yMSnmJbDKf/GB50000000003972079.jpg" alt="Pomelo" className="w-9 h-9 rounded-lg object-cover" data-id="element-571" />
            <div className="flex flex-col leading-tight" data-id="element-572">
              <span className="font-semibold text-base tracking-tight" data-id="element-573">
                Pomelo
              </span>
              <span className="text-[10px] uppercase tracking-widest text-slate-500 font-medium" data-id="element-574">
                SME Cashflow Lending
              </span>
            </div>
          </div>
          <button className="lg:hidden text-slate-400 hover:text-white" onClick={() => setIsOpen(false)} data-id="element-575">
            <X className="w-5 h-5" data-id="element-576" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto py-4 px-3 space-y-6" data-id="element-577">
          {navSections.map(section => <div key={section.title} data-id="element-578">
              <div className="px-3 mb-2 text-[10px] font-semibold uppercase tracking-widest text-slate-500" data-id="element-579">
                {section.title}
              </div>
              <div className="space-y-1" data-id="element-580">
                {section.items.map(item => {
              const Icon = item.icon;
              const isActive = activeSection === item.id;
              return <button key={item.id} onClick={() => {
                setActiveSection(item.id);
                setIsOpen(false);
              }} className={`
                        relative w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all
                        ${isActive ? 'bg-emerald-400/10 text-emerald-300' : 'text-slate-400 hover:bg-slate-800/50 hover:text-slate-200'}
                      `} data-id="element-581">
                      <div className={`
                          absolute -left-3 top-1/2 -translate-y-1/2 w-1 h-6 rounded-r-full transition-all
                          ${isActive ? 'bg-emerald-400 opacity-100' : 'opacity-0'}
                        `} data-id="element-582" />
                      <Icon className={`w-4 h-4 ${isActive ? 'text-emerald-300' : 'text-slate-500'}`} data-id="element-583" />
                      {item.label}
                    </button>;
            })}
              </div>
            </div>)}
        </div>

        <div className="p-6 border-t border-slate-800" data-id="element-584">
          <div className="flex items-center justify-center gap-2 py-2 px-3 bg-red-500/10 text-red-400 rounded border border-red-500/20 text-xs font-bold tracking-widest" data-id="element-585">
            <ShieldAlert className="w-3 h-3" data-id="element-586" />
            CONFIDENTIAL
          </div>
        </div>
      </div>
    </>;
}